import { Route } from "@app/routes/_authenticated/_manager/invoice/$invoiceId";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Stack, Tab } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import InvoicePotentialItemsTable from "./invoice-potential-items-table.tsx";

interface Props {
    invoiceId: number;
}

export default function InvoicePotentialItemContainer({ invoiceId }: Props) {
    const search = Route.useSearch();
    const [activeTab, setActiveTab] = useState(search.tab2 ?? "time");

    const navigate = useNavigate();

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { ...search, tab2: tab } });
    };

    return (
        <Stack spacing={2}>
            <TabContext value={activeTab}>
                <TabList onChange={(_, value) => handleChangeTab(value)}>
                    <Tab value={"time"} label={"Time"} />
                    <Tab value={"travel"} label={"Travel Expenses"} />
                    <Tab value={"individual"} label={"Other Individual Expenses"} />
                    <Tab value={"office"} label={"Office Expenses"} />
                </TabList>
                <TabPanel value={"time"}>
                    <InvoicePotentialItemsTable invoiceId={invoiceId} categoryId={1} title={"Time"} />
                </TabPanel>
                <TabPanel value={"travel"}>
                    <InvoicePotentialItemsTable invoiceId={invoiceId} categoryId={2} title={"Travel Expenses"} />
                </TabPanel>
                <TabPanel value={"individual"}>
                    <InvoicePotentialItemsTable
                        invoiceId={invoiceId}
                        categoryId={3}
                        title={"Other Individual Expenses"}
                    />
                </TabPanel>
                <TabPanel value={"office"}>
                    <InvoicePotentialItemsTable invoiceId={invoiceId} categoryId={4} title={"Office Expenses"} />
                </TabPanel>
            </TabContext>
        </Stack>
    );
}
